import { motion } from "framer-motion";
import { DraftingCompass, Ruler, ScanLine, Wrench } from "lucide-react";
import { Reveal } from "./Reveal";

const capabilities = [
  {
    key: "ufficio-tecnico",
    icon: DraftingCompass,
    tag: "Via Kennedy 5",
    title: "Ufficio Tecnico",
    desc: "Progettazione e programmazione CAD/CAM avanzata.",
    items: ["Software CATIA", "Autodesk Inventor", "4 postazioni Open Mind CAD/CAM"],
  },
  {
    key: "metrologia",
    icon: Ruler,
    tag: "Via Kennedy 5",
    title: "Sala Metrologica",
    desc: "Collaudo e certificazione dimensionale.",
    items: [
      "Hexagon Global S",
      "Hexagon Global Lite",
      "Keyence — scansione ottica",
      "Profilometro",
      "Durometro",
      "Braccio laser Faro",
      "Proiettori di profili",
    ],
  },
  {
    key: "marcatura",
    icon: ScanLine,
    tag: "Reparto Marcatura",
    title: "Marcatura Laser",
    desc: "Tracciabilità e identificazione dei componenti.",
    items: ["Marcatrice Keyence MD-X2000A", "Sistema a 3 assi"],
  },
  {
    key: "tradizionali",
    icon: Wrench,
    tag: "Via Kennedy 7",
    title: "Macchine Tradizionali",
    desc: "Lavorazioni convenzionali e saldatura.",
    items: ["2 alesatrici SIP Genevoise", "1 tornio parallelo", "Reparto saldatura"],
  },
];

export const Capabilities = () => (
  <section id="competenze" data-testid="capabilities" className="border-t border-white/10 bg-black">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-red-600" />
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-red-600">Competenze Tecniche</span>
            </div>
            <h2 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tighter leading-none">
              Progettazione<br />e controllo
            </h2>
          </div>
          <p className="max-w-md text-zinc-400 leading-relaxed">
            Dalla progettazione CAD/CAM alla metrologia certificata, fino alla marcatura e alle
            lavorazioni tradizionali: competenze e strumenti che garantiscono precisione in ogni fase.
          </p>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
        {capabilities.map((c, i) => {
          const Icon = c.icon;
          return (
            <Reveal key={c.key} delay={i * 0.08}>
              <motion.div
                whileHover={{ backgroundColor: "rgba(255,255,255,0.03)" }}
                data-testid={`capability-${c.key}`}
                className="h-full border-b border-r border-white/10 p-8 flex flex-col"
              >
                <div className="flex items-center justify-between mb-8">
                  <div className="text-red-600"><Icon size={28} strokeWidth={1.4} /></div>
                  <span className="font-mono text-[10px] uppercase tracking-wider text-zinc-600">{c.tag}</span>
                </div>
                <h3 className="font-display font-bold text-2xl tracking-tight mb-2">{c.title}</h3>
                <p className="text-sm text-zinc-500 leading-relaxed mb-6">{c.desc}</p>
                <ul className="space-y-3">
                  {c.items.map((it) => (
                    <li key={it} className="flex items-start gap-3 text-sm text-zinc-200">
                      <span className="w-1.5 h-1.5 bg-red-600 rotate-45 shrink-0 mt-1.5" />
                      {it}
                    </li>
                  ))}
                </ul>
              </motion.div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
